// Auto-generated from region1.json + region2.json — do not edit manually.
// To update: re-run the combine script with the latest paginated API responses.

export const DDS_SUPPORTED_COUNTRIES = [
  {
    "code": "102",
    "name": "Angola",
    "flag": "🇦🇴",
    "states": [
      {
        "code": "1049",
        "name": "Bengo"
      },
      {
        "code": "1052",
        "name": "Cabinda"
      },
      {
        "code": "1054",
        "name": "Cuanza Norte"
      },
      {
        "code": "1055",
        "name": "Cuanza Sul"
      },
      {
        "code": "1065",
        "name": "Uíge"
      },
      {
        "code": "1066",
        "name": "Zaire"
      }
    ]
  },
  {
    "code": "176",
    "name": "Belize",
    "flag": "🇧🇿",
    "states": []
  },
  {
    "code": "105",
    "name": "Benin",
    "flag": "🇧🇯",
    "states": []
  },
  {
    "code": "178",
    "name": "Bolivia (Plurinational State of)",
    "flag": "🇧🇴",
    "states": [
      {
        "code": "1831",
        "name": "Beni"
      },
      {
        "code": "1833",
        "name": "Cochabamba"
      },
      {
        "code": "1834",
        "name": "La Paz"
      },
      {
        "code": "1836",
        "name": "Pando"
      },
      {
        "code": "1838",
        "name": "Santa Cruz"
      }
    ]
  },
  {
    "code": "180",
    "name": "Brazil",
    "flag": "🇧🇷",
    "states": [
      {
        "code": "1843",
        "name": "Acre"
      },
      {
        "code": "1845",
        "name": "Amapá"
      },
      {
        "code": "1846",
        "name": "Amazonas"
      },
      {
        "code": "1847",
        "name": "Bahia"
      },
      {
        "code": "1848",
        "name": "Ceará"
      },
      {
        "code": "1850",
        "name": "Espírito Santo"
      },
      {
        "code": "1851",
        "name": "Goiás"
      },
      {
        "code": "1852",
        "name": "Maranhão"
      },
      {
        "code": "1853",
        "name": "Mato Grosso"
      },
      {
        "code": "1854",
        "name": "Mato Grosso Do Sul"
      },
      {
        "code": "1855",
        "name": "Minas Gerais"
      },
      {
        "code": "1858",
        "name": "Pará"
      },
      {
        "code": "1857",
        "name": "Paraíba"
      },
      {
        "code": "1856",
        "name": "Paraná"
      },
      {
        "code": "1859",
        "name": "Pernambuco"
      },
      {
        "code": "1860",
        "name": "Piauí"
      },
      {
        "code": "1863",
        "name": "Rio Grande Do Sul"
      },
      {
        "code": "1864",
        "name": "Rondônia"
      },
      {
        "code": "1865",
        "name": "Roraima"
      },
      {
        "code": "1866",
        "name": "Santa Catarina"
      },
      {
        "code": "1868",
        "name": "São Paulo"
      },
      {
        "code": "1869",
        "name": "Tocantins"
      }
    ]
  },
  {
    "code": "109",
    "name": "Burundi",
    "flag": "🇧🇮",
    "states": []
  },
  {
    "code": "112",
    "name": "Cameroon",
    "flag": "🇨🇲",
    "states": [
      {
        "code": "1142",
        "name": "Adamaoua"
      },
      {
        "code": "1143",
        "name": "Centre"
      },
      {
        "code": "1144",
        "name": "Est"
      },
      {
        "code": "1146",
        "name": "Littoral"
      },
      {
        "code": "1148",
        "name": "Nord-Ouest"
      },
      {
        "code": "1149",
        "name": "Ouest"
      },
      {
        "code": "1150",
        "name": "Sud"
      },
      {
        "code": "1151",
        "name": "Sud-Ouest"
      }
    ]
  },
  {
    "code": "234",
    "name": "China",
    "flag": "🇨🇳",
    "states": [
      {
        "code": "2560",
        "name": "Yunnan Province"
      }
    ]
  },
  {
    "code": "185",
    "name": "Colombia",
    "flag": "🇨🇴",
    "states": [
      {
        "code": "1913",
        "name": "Amazonas"
      },
      {
        "code": "1914",
        "name": "Antioquia"
      },
      {
        "code": "1915",
        "name": "Arauca"
      },
      {
        "code": "1919",
        "name": "Caldas"
      },
      {
        "code": "1920",
        "name": "Caqueta"
      },
      {
        "code": "1921",
        "name": "Casanare"
      },
      {
        "code": "1922",
        "name": "Cauca"
      },
      {
        "code": "1923",
        "name": "Cesar"
      },
      {
        "code": "1927",
        "name": "Guainia"
      },
      {
        "code": "1928",
        "name": "Guaviare"
      },
      {
        "code": "1929",
        "name": "Huila"
      },
      {
        "code": "1930",
        "name": "La Guajira"
      },
      {
        "code": "1931",
        "name": "Magdalena"
      },
      {
        "code": "1932",
        "name": "Meta"
      },
      {
        "code": "1933",
        "name": "Narino"
      },
      {
        "code": "1934",
        "name": "Norte De Santander"
      },
      {
        "code": "1936",
        "name": "Putumayo"
      },
      {
        "code": "1937",
        "name": "Quindio"
      },
      {
        "code": "1938",
        "name": "Risaralda"
      },
      {
        "code": "1940",
        "name": "Santander"
      },
      {
        "code": "1942",
        "name": "Tolima"
      },
      {
        "code": "1943",
        "name": "Valle Del Cauca"
      },
      {
        "code": "1944",
        "name": "Vaupes"
      },
      {
        "code": "1945",
        "name": "Vichada"
      }
    ]
  },
  {
    "code": "115",
    "name": "Comoros",
    "flag": "🇰🇲",
    "states": []
  },
  {
    "code": "186",
    "name": "Costa Rica",
    "flag": "🇨🇷",
    "states": []
  },
  {
    "code": "117",
    "name": "Côte D'Ivoire",
    "flag": "🇨🇮",
    "states": [
      {
        "code": "1199",
        "name": "Bas-Sassandra"
      },
      {
        "code": "1200",
        "name": "Comoé"
      },
      {
        "code": "1204",
        "name": "Lagunes"
      },
      {
        "code": "1205",
        "name": "Montagnes"
      }
    ]
  },
  {
    "code": "118",
    "name": "Democratic Republic of the Congo",
    "flag": "🇨🇩",
    "states": [
      {
        "code": "1237",
        "name": "Équateur"
      },
      {
        "code": "1216",
        "name": "Ituri"
      },
      {
        "code": "1222",
        "name": "Kwango"
      },
      {
        "code": "1227",
        "name": "Maniema"
      },
      {
        "code": "1229",
        "name": "Nord-Kivu"
      },
      {
        "code": "1232",
        "name": "Sud-Kivu"
      }
    ]
  },
  {
    "code": "188",
    "name": "Dominica",
    "flag": "🇩🇲",
    "states": []
  },
  {
    "code": "189",
    "name": "Dominican Republic",
    "flag": "🇩🇴",
    "states": []
  },
  {
    "code": "190",
    "name": "Ecuador",
    "flag": "🇪🇨",
    "states": [
      {
        "code": "1996",
        "name": "Emeralds"
      },
      {
        "code": "1998",
        "name": "Guayas"
      },
      {
        "code": "2001",
        "name": "Los Rios"
      },
      {
        "code": "2002",
        "name": "Manabi"
      }
    ]
  },
  {
    "code": "191",
    "name": "El Salvador",
    "flag": "🇸🇻",
    "states": []
  },
  {
    "code": "121",
    "name": "Equatorial Guinea",
    "flag": "🇬🇶",
    "states": []
  },
  {
    "code": "124",
    "name": "Ethiopia",
    "flag": "🇪🇹",
    "states": [
      {
        "code": "1291",
        "name": "Amhara"
      },
      {
        "code": "1292",
        "name": "Benishangul Gumz"
      },
      {
        "code": "1294",
        "name": "Gambela"
      },
      {
        "code": "1296",
        "name": "Oromia"
      },
      {
        "code": "1298",
        "name": "Snnp"
      },
      {
        "code": "1301",
        "name": "Tigray"
      }
    ]
  },
  {
    "code": "348",
    "name": "Fiji",
    "flag": "🇫🇯",
    "states": [
      {
        "code": "3993",
        "name": "Central Division"
      },
      {
        "code": "3994",
        "name": "Eastern Division"
      },
      {
        "code": "3995",
        "name": "Northern  Division"
      },
      {
        "code": "3996",
        "name": "Western Division"
      }
    ]
  },
  {
    "code": "127",
    "name": "Gabon",
    "flag": "🇬🇦",
    "states": []
  },
  {
    "code": "129",
    "name": "Ghana",
    "flag": "🇬🇭",
    "states": [
      {
        "code": "1321",
        "name": "Ashanti"
      },
      {
        "code": "1322",
        "name": "Brong Ahafo"
      },
      {
        "code": "1323",
        "name": "Central"
      },
      {
        "code": "1324",
        "name": "Eastern"
      },
      {
        "code": "1329",
        "name": "Volta"
      },
      {
        "code": "1330",
        "name": "Western"
      }
    ]
  },
  {
    "code": "194",
    "name": "Grenada",
    "flag": "🇬🇩",
    "states": [
      {
        "code": "2031",
        "name": "Saint Andrew"
      }
    ]
  },
  {
    "code": "196",
    "name": "Guatemala",
    "flag": "🇬🇹",
    "states": []
  },
  {
    "code": "131",
    "name": "Guinea",
    "flag": "🇬🇳",
    "states": [
      {
        "code": "1334",
        "name": "Faranah"
      },
      {
        "code": "1338",
        "name": "Mamou"
      },
      {
        "code": "1339",
        "name": "Nzerekore"
      }
    ]
  },
  {
    "code": "197",
    "name": "Guyana",
    "flag": "🇬🇾",
    "states": []
  },
  {
    "code": "198",
    "name": "Haiti",
    "flag": "🇭🇹",
    "states": [
      {
        "code": "2073",
        "name": "Grand-Anse"
      },
      {
        "code": "2075",
        "name": "Nord"
      },
      {
        "code": "2076",
        "name": "Nord-Est"
      },
      {
        "code": "2077",
        "name": "Nord-Ouest"
      }
    ]
  },
  {
    "code": "199",
    "name": "Honduras",
    "flag": "🇭🇳",
    "states": [
      {
        "code": "2081",
        "name": "Atlantida"
      },
      {
        "code": "2082",
        "name": "Choluteca"
      },
      {
        "code": "2083",
        "name": "Colon"
      },
      {
        "code": "2084",
        "name": "Comayagua"
      },
      {
        "code": "2085",
        "name": "Copan"
      },
      {
        "code": "2086",
        "name": "Cortes"
      },
      {
        "code": "2087",
        "name": "El Paraiso"
      },
      {
        "code": "2088",
        "name": "Francisco Morazan"
      },
      {
        "code": "2089",
        "name": "Gracias A Dios"
      },
      {
        "code": "2090",
        "name": "Intibuca"
      },
      {
        "code": "2091",
        "name": "Islas De La Bahia"
      },
      {
        "code": "2092",
        "name": "La Paz"
      },
      {
        "code": "2093",
        "name": "Lempira"
      },
      {
        "code": "2094",
        "name": "Ocotepeque"
      },
      {
        "code": "2095",
        "name": "Olancho"
      },
      {
        "code": "2096",
        "name": "Santa Barbara"
      },
      {
        "code": "2097",
        "name": "Valle"
      },
      {
        "code": "2098",
        "name": "Yoro"
      }
    ]
  },
  {
    "code": "240",
    "name": "India",
    "flag": "🇮🇳",
    "states": [
      {
        "code": "2578",
        "name": "Andhra Pradesh"
      },
      {
        "code": "2595",
        "name": "Karnataka"
      },
      {
        "code": "2596",
        "name": "Kerala"
      },
      {
        "code": "2598",
        "name": "Madhya Pradesh"
      },
      {
        "code": "2599",
        "name": "Maharashtra"
      },
      {
        "code": "2609",
        "name": "Tamil Nadu"
      },
      {
        "code": "2610",
        "name": "Telangana"
      }
    ]
  },
  {
    "code": "241",
    "name": "Indonesia",
    "flag": "🇮🇩",
    "states": [
      {
        "code": "2615",
        "name": "Aceh"
      },
      {
        "code": "2616",
        "name": "Bali"
      },
      {
        "code": "2617",
        "name": "Banten"
      },
      {
        "code": "2618",
        "name": "Bengkulu"
      },
      {
        "code": "2619",
        "name": "Daerah Istimewa Yogyakarta"
      },
      {
        "code": "2621",
        "name": "Gorontalo"
      },
      {
        "code": "2622",
        "name": "Jambi"
      },
      {
        "code": "2623",
        "name": "Jawa Barat"
      },
      {
        "code": "2624",
        "name": "Jawa Tengah"
      },
      {
        "code": "2625",
        "name": "Jawa Timur"
      },
      {
        "code": "2626",
        "name": "Kalimantan Barat"
      },
      {
        "code": "2627",
        "name": "Kalimantan Selatan"
      },
      {
        "code": "2628",
        "name": "Kalimantan Tengah"
      },
      {
        "code": "2629",
        "name": "Kalimantan Timur"
      },
      {
        "code": "2630",
        "name": "Kalimantan Utara"
      },
      {
        "code": "2631",
        "name": "Kepulauan Bangka Belitung"
      },
      {
        "code": "2632",
        "name": "Kepulauan Riau"
      },
      {
        "code": "2633",
        "name": "Lampung"
      },
      {
        "code": "2634",
        "name": "Maluku"
      },
      {
        "code": "2635",
        "name": "Maluku Utara"
      },
      {
        "code": "2636",
        "name": "Nusa Tenggara Barat"
      },
      {
        "code": "2637",
        "name": "Nusa Tenggara Timur"
      },
      {
        "code": "2638",
        "name": "Papua"
      },
      {
        "code": "2639",
        "name": "Papua Barat"
      },
      {
        "code": "2640",
        "name": "Riau"
      },
      {
        "code": "2641",
        "name": "Sulawesi Barat"
      },
      {
        "code": "2642",
        "name": "Sulawesi Selatan"
      },
      {
        "code": "2643",
        "name": "Sulawesi Tengah"
      },
      {
        "code": "2644",
        "name": "Sulawesi Tenggara"
      },
      {
        "code": "2645",
        "name": "Sulawesi Utara"
      },
      {
        "code": "2646",
        "name": "Sumatera Barat"
      },
      {
        "code": "2647",
        "name": "Sumatera Selatan"
      },
      {
        "code": "2648",
        "name": "Sumatera Utara"
      }
    ]
  },
  {
    "code": "200",
    "name": "Jamaica",
    "flag": "🇯🇲",
    "states": []
  },
  {
    "code": "137",
    "name": "Kenya",
    "flag": "🇰🇪",
    "states": [
      {
        "code": "1355",
        "name": "Bungoma"
      },
      {
        "code": "1356",
        "name": "Busia"
      },
      {
        "code": "1358",
        "name": "Embu"
      },
      {
        "code": "1359",
        "name": "Garissa"
      },
      {
        "code": "1360",
        "name": "Homa Bay"
      },
      {
        "code": "1361",
        "name": "Isiolo"
      },
      {
        "code": "1363",
        "name": "Kakamega"
      },
      {
        "code": "1364",
        "name": "Kericho"
      },
      {
        "code": "1365",
        "name": "Kiambu"
      },
      {
        "code": "1366",
        "name": "Kilifi"
      },
      {
        "code": "1367",
        "name": "Kirinyaga"
      },
      {
        "code": "1368",
        "name": "Kisii"
      },
      {
        "code": "1369",
        "name": "Kisumu"
      },
      {
        "code": "1370",
        "name": "Kitui"
      },
      {
        "code": "1371",
        "name": "Kwale"
      },
      {
        "code": "1373",
        "name": "Lamu"
      },
      {
        "code": "1374",
        "name": "Machakos"
      },
      {
        "code": "1375",
        "name": "Makueni"
      },
      {
        "code": "1376",
        "name": "Mandera"
      },
      {
        "code": "1377",
        "name": "Marsabit"
      },
      {
        "code": "1378",
        "name": "Meru"
      },
      {
        "code": "1379",
        "name": "Migori"
      },
      {
        "code": "1381",
        "name": "Murang'A"
      },
      {
        "code": "1382",
        "name": "Nairobi"
      },
      {
        "code": "1383",
        "name": "Nakuru"
      },
      {
        "code": "1384",
        "name": "Nandi"
      },
      {
        "code": "1385",
        "name": "Narok"
      },
      {
        "code": "1386",
        "name": "Nyamira"
      },
      {
        "code": "1387",
        "name": "Nyandarua"
      },
      {
        "code": "1388",
        "name": "Nyeri"
      },
      {
        "code": "1389",
        "name": "Samburu"
      },
      {
        "code": "1390",
        "name": "Siaya"
      },
      {
        "code": "1391",
        "name": "Taita Taveta"
      },
      {
        "code": "1392",
        "name": "Tana River"
      },
      {
        "code": "1393",
        "name": "Tharaka-Nithi"
      },
      {
        "code": "1394",
        "name": "Trans Nzoia"
      },
      {
        "code": "1395",
        "name": "Turkana"
      },
      {
        "code": "1396",
        "name": "Uasin Gishu"
      },
      {
        "code": "1397",
        "name": "Vihiga"
      },
      {
        "code": "1398",
        "name": "Wajir"
      },
      {
        "code": "1399",
        "name": "West Pokot"
      }
    ]
  },
  {
    "code": "252",
    "name": "Lao People's Democratic Republic",
    "flag": "🇱🇦",
    "states": [
      {
        "code": "2800",
        "name": "Attapeu"
      },
      {
        "code": "2803",
        "name": "Champasak"
      },
      {
        "code": "2810",
        "name": "Salavan"
      },
      {
        "code": "2816",
        "name": "Xekong"
      }
    ]
  },
  {
    "code": "139",
    "name": "Liberia",
    "flag": "🇱🇷",
    "states": []
  },
  {
    "code": "141",
    "name": "Madagascar",
    "flag": "🇲🇬",
    "states": []
  },
  {
    "code": "142",
    "name": "Malawi",
    "flag": "🇲🇼",
    "states": [
      {
        "code": "1434",
        "name": "Central Region"
      },
      {
        "code": "1435",
        "name": "Northern Region"
      },
      {
        "code": "1436",
        "name": "Southern Region"
      }
    ]
  },
  {
    "code": "254",
    "name": "Malaysia",
    "flag": "🇲🇾",
    "states": []
  },
  {
    "code": "202",
    "name": "Mexico",
    "flag": "🇲🇽",
    "states": [
      {
        "code": "2121",
        "name": "Chiapas"
      },
      {
        "code": "2136",
        "name": "Oaxaca"
      },
      {
        "code": "2143",
        "name": "Tabasco"
      },
      {
        "code": "2146",
        "name": "Veracruz De Ignacio De La Llave"
      }
    ]
  },
  {
    "code": "353",
    "name": "Micronesia (Federated States of)",
    "flag": "🇫🇲",
    "states": [
      {
        "code": "4006",
        "name": "Kosrae"
      },
      {
        "code": "4007",
        "name": "Pohnpei"
      }
    ]
  },
  {
    "code": "257",
    "name": "Myanmar",
    "flag": "🇲🇲",
    "states": [
      {
        "code": "2884",
        "name": "Region"
      },
      {
        "code": "2885",
        "name": "State"
      }
    ]
  },
  {
    "code": "204",
    "name": "Nicaragua",
    "flag": "🇳🇮",
    "states": [
      {
        "code": "2152",
        "name": "Boaco"
      },
      {
        "code": "2153",
        "name": "Carazo"
      },
      {
        "code": "2156",
        "name": "Estelí"
      },
      {
        "code": "2158",
        "name": "Jinotega"
      },
      {
        "code": "2160",
        "name": "Madriz"
      },
      {
        "code": "2161",
        "name": "Managua"
      },
      {
        "code": "2163",
        "name": "Matagalpa"
      },
      {
        "code": "2164",
        "name": "Nueva Segovia"
      }
    ]
  },
  {
    "code": "151",
    "name": "Nigeria",
    "flag": "🇳🇬",
    "states": [
      {
        "code": "1529",
        "name": "Ekiti"
      },
      {
        "code": "1544",
        "name": "Ogun"
      },
      {
        "code": "1545",
        "name": "Ondo"
      },
      {
        "code": "1546",
        "name": "Osun"
      }
    ]
  },
  {
    "code": "205",
    "name": "Panama",
    "flag": "🇵🇦",
    "states": []
  },
  {
    "code": "361",
    "name": "Papua New Guinea",
    "flag": "🇵🇬",
    "states": []
  },
  {
    "code": "206",
    "name": "Paraguay",
    "flag": "🇵🇾",
    "states": [
      {
        "code": "2183",
        "name": "Alto Paraná"
      },
      {
        "code": "2184",
        "name": "Amambay"
      },
      {
        "code": "2189",
        "name": "Canindeyú"
      }
    ]
  },
  {
    "code": "207",
    "name": "Peru",
    "flag": "🇵🇪",
    "states": [
      {
        "code": "2200",
        "name": "Amazonas"
      },
      {
        "code": "2204",
        "name": "Ayacucho"
      },
      {
        "code": "2205",
        "name": "Cajamarca"
      },
      {
        "code": "2207",
        "name": "Cusco"
      },
      {
        "code": "2209",
        "name": "Huanuco"
      },
      {
        "code": "2211",
        "name": "Junin"
      },
      {
        "code": "2215",
        "name": "Loreto"
      },
      {
        "code": "2216",
        "name": "Madre De Dios"
      },
      {
        "code": "2218",
        "name": "Pasco"
      },
      {
        "code": "2220",
        "name": "Puno"
      },
      {
        "code": "2221",
        "name": "San Martin"
      },
      {
        "code": "2224",
        "name": "Ucayali"
      }
    ]
  },
  {
    "code": "263",
    "name": "Philippines",
    "flag": "🇵🇭",
    "states": [
      {
        "code": "2913",
        "name": "Autonomous Region In Muslim Mindanao (Armm)"
      },
      {
        "code": "2915",
        "name": "Mimaropa Region"
      },
      {
        "code": "2923",
        "name": "Region Vi (Western Visayas)"
      },
      {
        "code": "2924",
        "name": "Region Vii (Central Visayas)"
      },
      {
        "code": "2926",
        "name": "Region X (Northern Mindanao)"
      },
      {
        "code": "2927",
        "name": "Region Xi (Davao Region)"
      },
      {
        "code": "2928",
        "name": "Region Xii (Soccsksargen)"
      }
    ]
  },
  {
    "code": "152",
    "name": "Rwanda",
    "flag": "🇷🇼",
    "states": []
  },
  {
    "code": "211",
    "name": "Saint Lucia",
    "flag": "🇱🇨",
    "states": []
  },
  {
    "code": "363",
    "name": "Samoa",
    "flag": "🇼🇸",
    "states": []
  },
  {
    "code": "157",
    "name": "Sierra Leone",
    "flag": "🇸🇱",
    "states": [
      {
        "code": "1584",
        "name": "Eastern"
      },
      {
        "code": "1585",
        "name": "North Western"
      },
      {
        "code": "1586",
        "name": "Northern"
      },
      {
        "code": "1587",
        "name": "Southern"
      },
      {
        "code": "1588",
        "name": "Western"
      }
    ]
  },
  {
    "code": "364",
    "name": "Solomon Islands",
    "flag": "🇸🇧",
    "states": []
  },
  {
    "code": "271",
    "name": "Sri Lanka",
    "flag": "🇱🇰",
    "states": []
  },
  {
    "code": "216",
    "name": "Suriname",
    "flag": "🇸🇷",
    "states": [
      {
        "code": "2268",
        "name": "Brokopondo"
      },
      {
        "code": "2269",
        "name": "Commewijne"
      },
      {
        "code": "2270",
        "name": "Coronie"
      },
      {
        "code": "2271",
        "name": "Marowijne"
      },
      {
        "code": "2272",
        "name": "Nickerie"
      },
      {
        "code": "2273",
        "name": "Para"
      },
      {
        "code": "2274",
        "name": "Paramaribo"
      },
      {
        "code": "2275",
        "name": "Saramacca"
      },
      {
        "code": "2276",
        "name": "Sipaliwini"
      },
      {
        "code": "2277",
        "name": "Wanica"
      }
    ]
  },
  {
    "code": "275",
    "name": "Thailand",
    "flag": "🇹🇭",
    "states": [
      {
        "code": "3016",
        "name": "Chiang Mai"
      },
      {
        "code": "3017",
        "name": "Chiang Rai"
      },
      {
        "code": "3019",
        "name": "Chumphon"
      },
      {
        "code": "3024",
        "name": "Krabi"
      },
      {
        "code": "3025",
        "name": "Lampang"
      },
      {
        "code": "3029",
        "name": "Mae Hong Son"
      },
      {
        "code": "3037",
        "name": "Nakhon Si Thammarat"
      },
      {
        "code": "3045",
        "name": "Phangnga"
      },
      {
        "code": "3057",
        "name": "Ranong"
      },
      {
        "code": "3073",
        "name": "Surat Thani"
      },
      {
        "code": "3075",
        "name": "Tak"
      }
    ]
  },
  {
    "code": "276",
    "name": "Timor-Leste",
    "flag": "🇹🇱",
    "states": []
  },
  {
    "code": "162",
    "name": "Togo",
    "flag": "🇹🇬",
    "states": []
  },
  {
    "code": "217",
    "name": "Trinidad And Tobago",
    "flag": "🇹🇹",
    "states": []
  },
  {
    "code": "165",
    "name": "Uganda",
    "flag": "🇺🇬",
    "states": []
  },
  {
    "code": "166",
    "name": "United Republic of Tanzania",
    "flag": "🇹🇿",
    "states": [
      {
        "code": "1679",
        "name": "Arusha"
      },
      {
        "code": "1683",
        "name": "Iringa"
      },
      {
        "code": "1684",
        "name": "Kagera"
      },
      {
        "code": "1688",
        "name": "Kigoma"
      },
      {
        "code": "1689",
        "name": "Kilimanjaro"
      },
      {
        "code": "1694",
        "name": "Mara"
      },
      {
        "code": "1695",
        "name": "Mbeya"
      },
      {
        "code": "1703",
        "name": "Ruvuma"
      },
      {
        "code": "1709",
        "name": "Tanga"
      }
    ]
  },
  {
    "code": "369",
    "name": "Vanuatu",
    "flag": "🇻🇺",
    "states": []
  },
  {
    "code": "281",
    "name": "Viet Nam",
    "flag": "🇻🇳",
    "states": [
      {
        "code": "3205",
        "name": "An Giang"
      },
      {
        "code": "3206",
        "name": "Ba Ria - Vung Tau"
      },
      {
        "code": "3207",
        "name": "Bac Giang"
      },
      {
        "code": "3208",
        "name": "Bac Kan"
      },
      {
        "code": "3209",
        "name": "Bac Lieu"
      },
      {
        "code": "3210",
        "name": "Bac Ninh"
      },
      {
        "code": "3211",
        "name": "Ben Tre"
      },
      {
        "code": "3212",
        "name": "Binh Dinh"
      },
      {
        "code": "3213",
        "name": "Binh Duong"
      },
      {
        "code": "3214",
        "name": "Binh Phuoc"
      },
      {
        "code": "3215",
        "name": "Binh Thuan"
      },
      {
        "code": "3216",
        "name": "Ca Mau"
      },
      {
        "code": "3217",
        "name": "Can Tho City"
      },
      {
        "code": "3218",
        "name": "Cao Bang"
      },
      {
        "code": "3219",
        "name": "Da Nang City"
      },
      {
        "code": "3220",
        "name": "Dak Lak"
      },
      {
        "code": "3221",
        "name": "Dak Nong"
      },
      {
        "code": "3222",
        "name": "Dien Bien"
      },
      {
        "code": "3223",
        "name": "Dong Nai"
      },
      {
        "code": "3224",
        "name": "Dong Thap"
      },
      {
        "code": "3225",
        "name": "Gia Lai"
      },
      {
        "code": "3226",
        "name": "Ha Giang"
      },
      {
        "code": "3227",
        "name": "Ha Nam"
      },
      {
        "code": "3228",
        "name": "Ha Noi"
      },
      {
        "code": "3229",
        "name": "Ha Tinh"
      },
      {
        "code": "3230",
        "name": "Hai Duong"
      },
      {
        "code": "3231",
        "name": "Hai Phong City"
      },
      {
        "code": "3232",
        "name": "Hau Giang"
      },
      {
        "code": "3233",
        "name": "Ho Chi Minh City"
      },
      {
        "code": "3234",
        "name": "Hoa Binh"
      },
      {
        "code": "3235",
        "name": "Hung Yen"
      },
      {
        "code": "3236",
        "name": "Khanh Hoa"
      },
      {
        "code": "3237",
        "name": "Kien Giang"
      },
      {
        "code": "3238",
        "name": "Kon Tum"
      },
      {
        "code": "3239",
        "name": "Lai Chau"
      },
      {
        "code": "3240",
        "name": "Lam Dong"
      },
      {
        "code": "3241",
        "name": "Lang Son"
      },
      {
        "code": "3242",
        "name": "Lao Cai"
      },
      {
        "code": "3243",
        "name": "Long An"
      },
      {
        "code": "3244",
        "name": "Nam Dinh"
      },
      {
        "code": "3245",
        "name": "Nghe An"
      },
      {
        "code": "3246",
        "name": "Ninh Binh"
      },
      {
        "code": "3247",
        "name": "Ninh Thuan"
      },
      {
        "code": "3248",
        "name": "Phu Tho"
      },
      {
        "code": "3249",
        "name": "Phu Yen"
      },
      {
        "code": "3250",
        "name": "Quang Binh"
      },
      {
        "code": "3251",
        "name": "Quang Nam"
      },
      {
        "code": "3252",
        "name": "Quang Ngai"
      },
      {
        "code": "3253",
        "name": "Quang Ninh"
      },
      {
        "code": "3254",
        "name": "Quang Tri"
      },
      {
        "code": "3255",
        "name": "Soc Trang"
      },
      {
        "code": "3256",
        "name": "Son La"
      },
      {
        "code": "3257",
        "name": "Tay Ninh"
      },
      {
        "code": "3258",
        "name": "Thai Binh"
      },
      {
        "code": "3259",
        "name": "Thai Nguyen"
      },
      {
        "code": "3260",
        "name": "Thanh Hoa"
      },
      {
        "code": "3261",
        "name": "Thua Thien Hue"
      },
      {
        "code": "3262",
        "name": "Tien Giang"
      },
      {
        "code": "3263",
        "name": "Tra Vinh"
      },
      {
        "code": "3264",
        "name": "Tuyen Quang"
      },
      {
        "code": "3265",
        "name": "Vinh Long"
      },
      {
        "code": "3266",
        "name": "Vinh Phuc"
      },
      {
        "code": "3267",
        "name": "Yen Bai"
      }
    ]
  },
  {
    "code": "168",
    "name": "Zambia",
    "flag": "🇿🇲",
    "states": []
  },
  {
    "code": "169",
    "name": "Zimbabwe",
    "flag": "🇿🇼",
    "states": [
      {
        "code": "1723",
        "name": "Manicaland"
      }
    ]
  }
];